export default __webpack_public_path__ + "static/media/icon-close-black.5ae53d37.svg";